var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatenexport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    x1: 21.336,
    y1: 13,
    x2: 31.368,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    x1: 29.262,
    y1: 10.845,
    x2: 31.417,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    x1: 29.262,
    y1: 15.155,
    x2: 31.417,
    y2: 13
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    d: "M12.913,1.66c0,0-0.33,0-0.33,0.33v16.02 c0,0,0,0.33,0.33,0.33h12.635c0,0,0.33,0,0.33-0.33V7.99c0,0,0-0.33-0.33-0.33h-5.434c0,0-0.33,0-0.33-0.331V1.99 c0,0,0-0.33-0.33-0.33H12.913z"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    x1: 19.724,
    y1: 1.66,
    x2: 25.793,
    y2: 7.729
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatenexport);
export default __webpack_public_path__ + "static/media/datenexport.8668834ee91bb345bbe54f132bb43a3c.svg";
export { ForwardRef as ReactComponent };